jQuery( '.icons-slider' ).slick( {
  slidesToShow: 4,
  autoplay: true,
  autoplaySpeed: 2000,
  swipeToSlide: true,
  speed: 600,
  cssEase: 'ease',
  arrows: false,
  variableWidth: true,
  responsive: [
    {
      breakpoint: 639,
      settings: {
        slidesToShow: 1,
        centerMode: true,
      }
    }
  ]
} );